import { Box, Container, Flex, Heading, Text } from "@chakra-ui/react";
import PageLayout from "@components/PageLayout";
import FadeTransition from "@components/animation/FadeTransition";

const AboutPage = () => {
  return (
    <PageLayout>
      <Container mb={32}>
        <Flex
          mb={12}
          alignItems="center"
          textAlign="center"
          flexDirection={{ base: "column", md: "row" }}
        >
          <Box>
            <FadeTransition>
              <Heading mt={16} as="h1">
                Retro is a simple planning tool for the modern agile team.
              </Heading>

              <Heading mt={16} as="h2" size="sm" fontWeight="medium">
                <i>
                  "Software is meant to feel light & effortless to use. Let's
                  keep it that way."
                </i>
              </Heading>
            </FadeTransition>

            <FadeTransition delay={0.1}>
              <Text mt={16} lineHeight={1.7}>
                RetroPlan.io is a completely solo bootstrapped project. First of
                all, thank you for checking out Retro! Retro has been a passion
                project for a long time after being frustrated with the current
                selection of planning tools available. If you're here, it's
                probably for the same reason. Planning takes time and is usually
                quite "dirty" - I'm trying to fix that.
              </Text>
            </FadeTransition>
          </Box>
        </Flex>
      </Container>
    </PageLayout>
  );
};

export default AboutPage;
